import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import { Typography } from '../Typography/Typography.styled';
import MapButton from '~/components/MapButton/MapButton.component';
import {
  ensureContrast,
  AA_SURFACE,
  AA_TEXT_PRIMARY_ON_LIGHT,
} from '~/modules/Helper/contrast.helper';
import * as S from './Footer.styled';

function Footer() {
  const configuration = useSelector(state => state.configuration);
  const {
    corFonteRodape,
    corFundoRodape,
    endereco,
    bairro,
    cidade,
    cep,
    telefone,
    atendimento,
  } = configuration;

  const corTexto = ensureContrast(
    corFonteRodape || AA_TEXT_PRIMARY_ON_LIGHT,
    corFundoRodape || AA_SURFACE,
    4.5,
    AA_TEXT_PRIMARY_ON_LIGHT
  );

  return (
    <S.Footer aria-label="Rodapé com endereço e contato">
      <Row justify="center" align="middle">
        <Col>
          <Typography.Paragraph style={{ color: corTexto, marginBottom: 8 }}>
            {[endereco, bairro, cidade, cep].filter(Boolean).join(' - ')}
          </Typography.Paragraph>

          <Typography.Paragraph style={{ marginBottom: 0, color: corTexto }}>
            {[telefone, atendimento].filter(Boolean).join(' - ')}
          </Typography.Paragraph>
        </Col>
        <S.MapButtonWrapper
          lg={2}
          xs={3}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MapButton rua={endereco} bairro={bairro} cidade={cidade} />
        </S.MapButtonWrapper>
      </Row>
    </S.Footer>
  );
}

export default Footer;
